import userRoleFilter from 'app/filters/userRole'

export default class UserRole {

    static USER = 'USER';
    static ADMIN = 'ADMIN';
    static ADVISOR = 'ADVISOR';

    static options(){

        return {
            'ADMIN': userRoleFilter(UserRole.ADMIN),
            'ADVISOR': userRoleFilter(UserRole.ADVISOR),
            'USER': userRoleFilter(UserRole.USER)
        };
    }
}